<template>
  <div class="leaflet-container">
    <Breadcrumb class="d-none d-sm-flex px-0" :items="vBreadcrums" />
    <!-- <v-container v-if="leaflet && leafletRendered"> -->
    <v-container class="upper">
      <!-- <v-row class="d-flex flex-row" v-if="leaflet && leafletRendered"> -->
      <v-row class="d-flex flex-row" v-if="leaflet">
        <v-col
          :cols="$vuetify.breakpoint.smAndUp ? 8 : 12"
          class="d-flex justify-start flex-column"
        >
          <h2 class="secondary--text">{{ leaflet.title }}</h2>
          <p v-if="leaflet.descr">{{ leaflet.descr }}</p>
        </v-col>
        <v-col
          cols="4"
          class="d-flex justify-end"
          v-if="$vuetify.breakpoint.smAndUp"
        >
          <v-btn class="primary white--text text-uppercase" to="/volantini"
            >Torna ai volantini</v-btn
          >
        </v-col>
      </v-row>
      <!--applies class iosFullscreen on ios app and ios safari/chrome-->
      <div
        :class="{ iosFullscreen: isIOSFullscreen }"
        id="leafet-viewer"
        ref="leafletViewer"
        style="background-color: var(--v-grey-lighten3) !important; border-color: var(--v-grey-lighten3) !important;"
      >
        <router-view v-if="showList" />
        <leaflet-viewer
          v-else
          v-show="showLeaflet"
          :leaflet="leaflet"
          ref="leafletViewerRef"
          @openDetail="openDetail"
          @slideChanged="slideChanged"
          :key="leafletId"
          :swiperHeight="swiperHeight"
          :fullscreen="leafletFullscreen"
        />
        <v-bottom-navigation
          :class="{ 'sticky-toolbar-top': isSticky }"
          id="leaflet-toolbar"
          dense
          flat
          background-color="secondary lighten-1"
          color="primary"
          class="elevation-0"
        >
          <v-slide-group
            multiple
            show-arrows
            class="leaflet-bottom-navigation"
            :class="
              $vuetify.breakpoint.xs ? 'd-flex flex-row' : 'd-flex flex-column'
            "
          >
            <v-menu
              :top="!isSticky"
              :bottom="isSticky"
              v-show="leaflet.leafletTypeId == 1"
              offset-y
              :close-on-content-click="false"
              :value="showSearch"
              attach="#leaflet-toolbar"
              content-class="elevation-0 rounded-0"
              v-if="categories && categories.length > 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  depressed
                  @click="
                    showCategories = !showCategories;
                    onShowSearch();
                  "
                >
                  <span class="secondary--text"
                    ><strong>{{
                      $t("leaflet.navigation.search.title")
                    }}</strong></span
                  >
                  <v-icon color="secondary">icon-search</v-icon>
                </v-btn>
              </template>
              <div class="px-4 py-2 grey lighten-3">
                <v-text-field
                  v-model="search"
                  filled
                  solo
                  dense
                  flat
                  hide-details
                  single-line
                  height="48"
                  clearable
                  ref="flyerinput"
                  class="search-input flyer-input"
                  placeholder="Cerca un prodotto"
                  @keydown.enter.native.prevent.stop="searchProducts"
                  ><template slot="append">
                    <v-icon color="default" @click.prevent.stop="searchProducts"
                      >$search</v-icon
                    >
                  </template></v-text-field
                >
              </div>
            </v-menu>
            <v-menu
              v-show="leaflet.leafletTypeId == 1"
              :top="!isSticky"
              :bottom="isSticky"
              offset-y
              attach="#leaflet-toolbar"
              content-class="rounded-0"
              v-if="categories && categories.length > 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  depressed
                  @click="handleShowCategory"
                >
                  <span class="secondary--text"
                    ><strong>{{
                      $t("leaflet.navigation.departments.title")
                    }}</strong></span
                  >
                  <v-icon color="secondary">$reparti</v-icon>
                </v-btn>
              </template>
              <v-sheet class="pa-2">
                <v-row no-gutters>
                  <v-col
                    v-for="category in categories"
                    :key="category.categoryId"
                    class="pa-1"
                    cols="3"
                    sm="2"
                    md="auto"
                  >
                    <v-btn
                      depressed
                      color="secondary"
                      width="73"
                      height="73"
                      class="category-leaflet-btn"
                      @click="
                        filterProducts(category.categoryId, category.name)
                      "
                    >
                      <div
                        class="d-flex flex-column justify-space-between py-2"
                      >
                        <div class="category-block-title white--text mb-2">
                          <strong>{{ category.name }}</strong>
                        </div>
                        <div>
                          <ebsn-img
                            width="35"
                            height="35"
                            :target="category"
                            path="category_info.ICON"
                            :alt="`Icona Categoria ${category.name}`"
                          />
                        </div>
                      </div>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-menu>
            <v-btn
              v-show="leaflet.leafletTypeId == 1"
              icon
              depressed
              @click="backToLeaflet"
              ><span class="secondary--text"
                ><strong>{{
                  $t("leaflet.navigation.browse.title")
                }}</strong></span
              >
              <v-icon color="secondary">$sfoglia</v-icon>
            </v-btn>

            <v-btn
              v-show="leaflet.leafletTypeId == 1"
              icon
              depressed
              @click.stop="toggleFullscreen"
              ><span class="secondary--text"
                ><strong>{{
                  $t("leaflet.navigation.zoom.title")
                }}</strong></span
              >
              <v-icon color="secondary">$zoom</v-icon>
            </v-btn>
            <v-btn
              v-if="leaflet"
              icon
              target="blank"
              :href="`${leaflet.baseLocation}${leaflet.location}`"
              @click="onLinkClick"
            >
              <span class="secondary--text"
                ><strong>{{
                  $t("leaflet.navigation.download.title")
                }}</strong></span
              >
              <v-icon color="secondary">icon-download-1</v-icon>
            </v-btn>
            <v-btn
              v-if="leaflet && categories && categories.length > 0"
              icon
              depressed
              @click="openleafletInfoModal"
            >
              <span class="secondary--text"
                ><strong>{{
                  $t("leaflet.navigation.info.title")
                }}</strong></span
              >
              <v-icon color="secondary">$info</v-icon>
            </v-btn>
          </v-slide-group>
          <div
            v-if="$vuetify.breakpoint.xs"
            class="d-flex flex-column fixed-text align-center secondary--text hidden-sm-and-up w-100"
          >
            Usa i comandi qui sopra per navigare il volantino
          </div>
        </v-bottom-navigation>
      </div>
      <!-- <div
        v-if="!$vuetify.breakpoint.xs"
        class="d-flex flex-column fixed-text align-center secondary--text w-100"
      >
        Usa i comandi qui sopra per navigare il volantino
      </div> -->
    </v-container>

    <!-- <v-container v-if="leaflet && leafletRendered && !showLeaflet">
      <h2>{{ leaflet.title }}</h2>
      <div>
        Dal
        {{ leaflet.fromDate | dayjs("format", "D  MMMM") }} al
        {{ leaflet.toDate | dayjs("format", "D  MMMM") }}
      </div>
      <p v-if="leaflet.descr">{{ leaflet.descr }}</p>
    </v-container> -->
    <v-container v-if="!showList">
      <div class="product-grid mt-2 mt-sm-0 pb-4 pb-md-0">
        <h2 v-if="headerSearch">
          <span>{{ $t("leaflet.searchResults") }}: </span>
          <span class="font-weight-regular">{{ headerSearch }}</span>
        </h2>
        <h2 v-if="headerCategory">
          <span>{{ $t("leaflet.allOffersIn") }} </span>
          <span class="text-lowercase">{{ headerCategory }}</span>
        </h2>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            xl="2"
            v-for="product in products"
            :key="product.productId"
          >
            <!-- <product-card-leaflet
            :product="product"
            :leaflet="leaflet"
            @openDetail="openDetailProduct"
          /> -->
            <ProductCard v-bind:product="product" :fromLeaflet="true" />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<style lang="scss">
.extended {
  top: 120px !important;
}
.sticky-toolbar-top {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
}
// .relative {
//   position: relative;
//   z-index: 8;
// }
.leaflet-container {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .v-bottom-navigation {
      position: fixed;
      bottom: 14%;
      z-index: 8;
      height: calc(56px + env(safe-area-inset-top) + 20px) !important;
    }
    .fixed-text {
      position: fixed;
      bottom: 8%;
      z-index: 8;
      background-color: $white;
      padding: 16px;
      width: 100%;
      height: 56px;
      font-weight: bold;
      font-size: 13px;
      @media (max-width: 375px) {
        font-size: 11px;
        padding: 8px;
      }
    }
  }
}
#leafet-viewer {
  isolation: isolate;
  // @media #{map-get($display-breakpoints, 'sm-and-down')} {
  position: relative;
  z-index: 8;
  // }
}
/*
what it does? It disables scroll on ios safari/chrome when
flyer is in fullscreen
*/
.body-fixed-position {
  position: fixed;
}
/*
sets the flyer in fullscreen mode in ios safari/chrome
*/
.iosFullscreen {
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  width: 100vw;
  height: 100%;
  .disable-zoom-on-safari {
    touch-action: unset !important;
  }
  .swiper-pagination,
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
  .draggable {
    pointer-events: none;
  }
  .swiper-container {
    max-width: unset !important;
    .imgage-container,
    .swiper-zoom-container {
      max-height: unset !important;
    }
  }
}

article {
  counter-reset: my-counter;
  h1 {
    line-height: normal !important;
  }
  .leaflet-information-wrapper {
    //padding: 20px 0;

    .leaflet-information {
      flex: 1 1 33.333%;
      &.has-icon {
        max-width: fit-content;
      }
      .v-icon {
        font-size: 50px !important;
        background-color: var(--v-primary-base) !important;
        border-radius: 20px;
      }
      &-text {
        max-width: 120px;
      }
      .counter {
        position: relative;
        isolation: isolate;
        &::before {
          counter-increment: my-counter;
          content: counter(my-counter);
          position: absolute;
          z-index: -1;
          font-size: 100px;
          font-weight: bold;
          line-height: 65px;
          color: var(--v-primary-lighten2);
        }
        &-left {
          &::before {
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        &-right {
          &::before {
            right: 0;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
@media (min-width: 960px) {
  article .leaflet-information-wrapper .leaflet-information .counter {
    &-left {
      &::before {
        transform: unset;
        left: -20px;
        top: 0;
      }
    }
    &-right {
      &::before {
        transform: unset;
        right: -20px;
        top: 0;
      }
    }
  }
}
#leaflet-toolbar {
  .v-btn__content {
    color: #000;
    font-weight: 500;
    span {
      font-size: 8px;
      padding: 4px;
      text-transform: uppercase;
    }
    i {
      font-size: 20px;
    }
  }
  &.v-item-group.v-bottom-navigation .v-btn {
    min-width: 70px;
  }
  .v-menu__content {
    max-width: 100%;
    left: 0 !important;
    right: 0;
    width: 100%;
  }
}
.leaflet-container {
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: transparent;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide-active {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: flex-end;
    -ms-flex-align: flex-end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
  }
  .swiper-slide-next {
    -webkit-box-pack: flex-start;
    -ms-flex-pack: flex-start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }

  .swiper-slide img {
    display: block;
    max-width: 100%;
    // height: 100%;
    object-fit: contain;
    max-height: inherit;
    // height: 100%;
  }

  .swiper-slide img {
    display: block;
    max-width: 100%;
    // height: 100%;
    object-fit: contain;
    max-height: inherit;
  }

  .imgage-container {
    box-sizing: content-box;
  }

  @media only screen and (min-width: 769px) {
    .swiper-slide:first-child {
      transition: transform 100ms;
    }

    .swiper-slide:first-child img {
      transition: box-shadow 500ms;
    }

    .swiper-slide.swiper-slide-active:first-child {
      transform: translateX(50%);
      z-index: 2;
    }

    .swiper-slide.swiper-slide-active:first-child img {
      box-shadow: 0px 32px 80px rgba(0, 0, 0, 0.35);
    }

    .swiper-slide:nth-child(2) {
      transition: transform 100ms;
    }

    .swiper-slide.swiper-slide-next:nth-child(2) {
      transform: translateX(55%);
      z-index: 1;
    }

    .swiper[dir="rtl"] .swiper-slide.swiper-slide-active:first-child {
      transform: translateX(-50%);
    }

    .swiper[dir="rtl"] .swiper-slide.swiper-slide-next:nth-child(2) {
      transform: translateX(-55%);
    }

    .swiper-slide-active {
      -webkit-box-pack: flex-end;
      -ms-flex-pack: flex-end;
      -webkit-justify-content: flex-end;
      justify-content: flex-end;
    }
  }

  .category-leaflet-btn {
    border-radius: 8px !important;
    .v-btn__content {
      flex-direction: column;
      .category-block-title {
        font-size: 10px;
        font-weight: normal;
        text-transform: none;
        white-space: initial;
        max-width: 70px;
      }
    }
  }
  .leaflet-page-container {
    position: relative;
    display: inline-block;
    max-height: 100%;
    max-width: 100%;
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    content: "";
  }

  // .draggable {
  //   cursor: pointer;
  //   position: absolute;
  //   &:hover {
  //     background-color: rgba(255, 221, 2, 0.35);
  //     border: 1px solid rgba(255, 221, 2, 1);
  //     transition: all 0.2s;
  //   }
  // }
  .image {
    max-width: 100%;
    max-height: 100%;
    // height: 100%;
  }
}
.fullscreen {
  .leaflet-container {
    .swiper-slide img {
      height: 100% !important;
    }
    .image {
      height: 100% !important;
    }
  }
}
.leaflet-dialog-fullscreen {
  display: flex;
  align-items: center;
  .exit-fullscreen-btn {
    position: absolute;
    z-index: 2;
    right: 10px;
  }
}
.v-dialog.vuedl-layout .v-btn {
  border: 0;
}
</style>
<script>
import Breadcrumb from "@/components/navigation/Breadcrumb.vue";
import LeafletViewer from "@/components/leaflet/LeafletViewer.vue";
import ProductCard from "@/components/product/ProductCard.vue";
import Popup from "@/components/Popup.vue";
import CTADetailLeaflet from "@/components/leaflet/CTADetailLeaflet.vue";
import LeafletInformationModal from "@/components/leaflet/LeafletInformationModal.vue";
import clickHandler from "~/mixins/clickHandler";
import downloadDocument from "~/mixins/downloadDocument";
import leafletService from "~/service/leafletService";
import customService from "@/service/grosmarketCustomService";
import get from "lodash/get";
import { mapState } from "vuex";
import isNumber from "lodash/isNumber";
import { mapGetters } from "vuex";
const header = {
  fullscreenHeader: 165,
  xsHeader: 165,
  smHeader: 0,
  desktopHeader: 40
};

export default {
  // eslint-disable-next-line vue/no-unused-components
  name: "Leaflet",
  components: {
    Breadcrumb,
    ProductCard,
    LeafletViewer
  },
  data() {
    return {
      URLcategory: null,
      isSticky: false,
      navOffsetTop: 0,
      componentKey: 0,
      isIOSFullscreen: false,
      leafletId: null,
      areaDetail: null,
      categories: [],
      showCategories: false,
      leaflet: {},
      leafletRendered: false,
      selectedArea: null,
      products: null,
      openProductDetail: false,
      showLeaflet: true,
      showSearch: false,
      search: "",
      leafletFullscreen: false,
      headerSearch: null,
      headerCategory: null,
      currentPage: 0,
      showList: false,
      dialog: false,
      leafletSlugId: null,
      swiperHeight: this.$vuetify.breakpoint.mdAndUp
        ? window.innerHeight - header.desktopHeader + "px"
        : this.$vuetify.breakpoint.xsOnly
        ? window.innerHeight - header.xsHeader + "px"
        : window.innerHeight - header.smHeader + "px"
    };
  },
  mixins: [clickHandler, downloadDocument],
  computed: {
    ...mapState({
      allCategories: ({ category }) => category.categoryTree
    }),
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    }),
    // meritaAssaggio() {
    //   let foundCampaign = this.facets
    //     ?.find(facet => facet.name == "Campaign")
    //     ?.find(facet => facet.name == "Merita Assaggio");
    //   return foundCampaign != null;
    // },
    // prodottiMese() {
    //   let foundCampaign = this.facets
    //     ?.find(facet => facet.name == "Campaign")
    //     ?.find(facet => facet.name == "Prodotti del mese");
    //   return foundCampaign != null;
    // },
    vBreadcrums() {
      // let b = this.breadcrumb;
      let b = [];
      b.push({
        to: { name: "Home" },
        text: "Homepage",
        exact: true
      });
      b.push({
        to: {
          name: "Leaflets"
        },
        text: "Volantini",
        exact: true
      });
      if (this.leaflet) {
        b.push({
          to: {
            name: "Leaflet",
            params: {
              volantino: this.$route.params.volantino
            }
          },
          text: this.leaflet.title,
          exact: true
        });
      }
      if (this.showList) {
        b.push({
          to: {
            name: "LeafletList"
          },
          text: "Lista",
          exact: true
        });
      }
      return b;
    },
    dialogWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100%";
        case "sm":
          return "80%";
        case "md":
          return "50%";
        case "lg":
          return "40%";
        case "xl":
          return "30%";
        default:
          return "auto";
      }
    },
    /**
     * Return true if the user is using ios safari/chrome
     */
    isIOSSafariOrChrome() {
      const ua = window.navigator.userAgent;
      const iOS = !!ua.match(/iP(ad|hone)/i);
      const webkit = !!ua.match(/WebKit/i);
      const isChrome = !!ua.match(/Chrome/i);

      return (iOS && webkit) || (iOS && isChrome);
    }
  },
  methods: {
    setLeaflet(leaflet) {
      this.leaflet = leaflet;
    },
    handleScroll() {
      const scrollY = window.scrollY;
      const target = document.getElementById("leaflet-toolbar");

      if (scrollY > this.navOffsetTop - 120) {
        this.isSticky = true;
        target.classList.add("extended"); // Replace 'active' with your desired class
      } else {
        this.isSticky = false;
        target.classList.remove("extended");
      }
    },

    /**
     * Handles pinchzoom behaviour on ios app in fullscreen mode
     */
    handleZoom() {
      let swiperInstance = this.$refs.leafletViewerRef.$refs.swiper.$swiper;
      if (this.isIOSFullscreen) {
        swiperInstance.zoom.enable();
        console.log(swiperInstance);
      } else {
        swiperInstance.zoom.disable();
      }
    },

    handleShowCategory() {
      this.showCategories = !this.showCategories;
      this.isIOSFullscreen = false;
      this.handleZoom();
    },

    async toggleFullscreen() {
      const _this = this;
      /**
       * Return true if the user is using ios app or ios safari/chrome
       */
      if (
        this.isIOSSafariOrChrome ||
        (window.cordova && window.cordova.platformId.toLowerCase() === "ios")
      ) {
        /**
         * Show flyer in fullscreen mode
         */

        this.isIOSFullscreen = true;
        this.handleZoom();
        this.showLeaflet = true;
      } else {
        if (_this.leafletFullscreen) {
          this.isSticky = false;
          let t = document.getElementById("leaflet-toolbar");
          t.classList.remove("extended");
          document.exitFullscreen().then(function() {
            if (_this.$vuetify.breakpoint.mdAndUp) {
              _this.swiperHeight =
                window.innerHeight - header.desktopHeader + "px";
              console.log(_this.swiperHeight);
            } else {
              _this.swiperHeight =
                window.innerHeight - header.mobileHeader + "px";
              console.log(_this.swiperHeight);
            }
          });
        } else if (document.webkitIsFullScreen == true) {
          this.isSticky = false;
          let t = document.getElementById("leaflet-toolbar");
          t.classList.remove("extended");
          document.webkitExitFullscreen().then(function() {
            if (_this.$vuetify.breakpoint.mdAndUp) {
              _this.swiperHeight =
                window.innerHeight - header.desktopHeader + "px";
              console.log(_this.swiperHeight);
            } else {
              _this.swiperHeight =
                window.innerHeight - header.mobileHeader + "px";
              console.log(_this.swiperHeight);
            }
          });
        } else {
          this.showLeaflet = true;
          let elem = this.$refs.leafletViewer;
          var methodToBeInvoked =
            elem.requestFullscreen ||
            elem.webkitRequestFullScreen ||
            elem["mozRequestFullscreen"] ||
            elem["msRequestFullscreen"];
          let _this = this;
          if (methodToBeInvoked) {
            methodToBeInvoked.call(elem).then(
              function() {
                _this.swiperHeight =
                  window.screen.height - header.fullscreenHeader + "px";
                console.log(_this.swiperHeight);
              },
              function(error) {
                console.log(error);
              }
            );
          }
        }
      }
    },

    exitFullscreen() {
      if (this.leafletFullscreen) {
        this.toggleFullscreen();
      }
    },
    exitHandler() {
      let attr =
        document.fullscreen === true ||
        document.webkitIsFullScreen === true ||
        document.mozFullScreen === true ||
        document.msFullscreenElement === true;

      if (attr === false) {
        this.leafletFullscreen = false;
      } else if (attr === true) {
        this.leafletFullscreen = true;
      }
    },

    async openDetail(areaDetail) {
      this.componentKey = this.componentKey++;
      //let slug = "asiago-fresco-dop-fette-gr100-agriform";
      this.exitFullscreen();
      this.selectedArea = await leafletService.searchProducts({
        parent_leaflet_id: this.leafletSlugId || this.leafletId,
        parent_leaflet_area_id: areaDetail.leafletAreaId,
        details: true
      });
      if (areaDetail) {
        if (areaDetail.link) {
          try {
            this.$emit("close");
            this.clicked(areaDetail.link);
          } catch (e) {
            this.$emit("close");
            if (areaDetail.link.indexOf("http") > -1) {
              if (this.$platform_is_cordova) {
                //if app open on _system browser
                window.cordova.InAppBrowser.open(areaDetail.link, "_system");
              } else {
                // if site open in a new tab
                window.open(areaDetail.link);
              }
            }
          }
          return;
        } else {
          let _this = this;
          if (
            areaDetail.metadata?.leafletareatype_cta?.IMAGE?.location ||
            (_this.selectedArea.data.products &&
              _this.selectedArea.data.products.length > 0)
          ) {
            this.$dialog.show(CTADetailLeaflet, {
              extraClass: "cta_detail_leaflet",
              hideToolbarLogo: true,
              toolbarColor: "white",
              icon: areaDetail ? areaDetail.iconType : undefined,
              areaDetail: areaDetail,
              products: this.selectedArea.data.products,
              leaflet: this.leaflet,
              width: this.dialogWidth,
              fullscreen: this.$vuetify.breakpoint.xsOnly,
              paginationClass: `cta-leaflet-${this.componentKey}`,
              xs: 1,
              sm: 1,
              md: 1,
              lg: 1,
              xl: 1,
              showBullets: false,
              showArrows: true
            });
          }
        }
      }
    },
    async slideChanged(index) {
      console.log("LEAFLET:", index);
      this.currentPage = index;

      if (window.innerWidth > 769 && index != 0) {
        index = [index, index + 1];
      }
      this.fetchProducts(index);
    },

    async fetchLeaflet() {
      if (isNaN(this.leafletId)) {
        this.leaflet = await customService.getLeafletBySlug(this.leafletId);
        if (this.leaflet) {
          this.leafletSlugId = this.leaflet.leafletId;
        }
      } else {
        this.leaflet = await leafletService.getLeafletById(this.leafletId);
      }
      await this.fetchFacets();
      this.leafletRendered = true;

      // this.leafletRendered = true;

      let _this = this;

      let foundCategories = _this.facets?.find(
        facet => facet.name == "Categorie"
      );

      this.categories = this.allCategories.filter(aCategory => {
        let available = foundCategories?.values?.find(
          fCategory => fCategory.id == aCategory.categoryId
        );
        return available != null;
      });
    },
    async fetchProducts(pageNumber) {
      let response = await leafletService.searchProducts({
        parent_leaflet_id: this.leafletSlugId || this.leafletId,
        parent_leaflet_page_number_id: pageNumber
      });

      this.products = response.data.products;
      this.products = this.products.filter(product => {
        return (
          product.available &&
          product.available > 0 &&
          product.priceDisplay &&
          product.priceDisplay > 0
        );
      });
    },
    async fetchFacets() {
      let response = await leafletService.searchProducts({
        parent_leaflet_id: this.leafletSlugId || this.leafletId,
        page_size: 0
      });
      console.log(response);
      this.facets = response.data.facets;
    },
    async filterProducts(categoryId, categoryName) {
      this.exitFullscreen();
      let response = await leafletService.searchProducts({
        parent_leaflet_id: this.leafletSlugId || this.leafletId,
        parent_category_id: categoryId
      });
      this.headerSearch = null;
      this.headerCategory = categoryName;
      this.products = response.data.products;
      this.products = this.products.filter(product => {
        return (
          product.available &&
          product.available > 0 &&
          product.priceDisplay &&
          product.priceDisplay > 0
        );
      });
      this.showLeaflet = false;
      this.$router.replace({
        query: { ...this.$route.query, category: categoryId }
      });
      if (this.showList) {
        this.$router.push({ name: "Leaflet" });
      }
    },
    async searchProducts() {
      this.exitFullscreen();
      let response = await leafletService.searchProducts({
        parent_leaflet_id: this.leafletSlugId || this.leafletId,
        q: this.search
      });
      this.headerCategory = null;
      this.headerSearch = this.search;
      this.products = response.data.products;
      var el = document.getElementsByClassName("flyer-input");
      el[0].blur();
      this.iosFullscreen = false;
      const iosFullscreen = document.getElementById("leafet-viewer");
      iosFullscreen.classList.remove("iosFullscreen");
      this.showSearch = false;
      this.showLeaflet = false;
      if (this.showList) {
        this.$router.push({ name: "Leaflet" });
      }
      this.$refs.flyerinput.blur();
    },
    backToLeaflet() {
      this.exitFullscreen();

      if (this.isIOSFullscreen) {
        this.isIOSFullscreen = false;
      }
      this.handleZoom();

      this.showLeaflet = true;
      this.headerSearch = null;
      this.headerCategory = null;
      if (this.showList) {
        this.$router.push({ name: "Leaflet" });
      }
    },
    onLinkClick(e) {
      var url = e.currentTarget.href;
      let fileName = "";
      this.$emit("close");
      this.$nextTick(() => {
        if (
          this.$platform_is_cordova &&
          e.currentTarget.href.endsWith(".pdf")
        ) {
          fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
          fileName = fileName.substring(0, fileName.length - 4);
          this.handleReceiptDownload(url, fileName);
        } else {
          this.clicked(e);
        }
      });
    },
    onShowSearch() {
      this.showSearch = !this.showSearch;
      if (!this.showSearch) {
        var el = document.getElementsByClassName("flyer-input");
        el[0].blur();
      }
    },
    openleafletInfoModal() {
      this.$dialog.show(LeafletInformationModal, {
        width: this.dialogWidth,
        fullscreen: this.$vuetify.breakpoint.smAndDown
      });
    },
    checkPopup() {
      let _this = this;
      try {
        let popupConfig = get(_this.leaflet, "metaData.leaflet_popup");
        if (popupConfig?.ACTIVE) {
          let popupMap = global.vm.$store.getters["app/getPopupMap"];
          let canOpenPopup = false;

          if (typeof popupConfig.REOPENING_DAYS_DELAY == "number") {
            let lastTimeOpen =
              popupMap[_this.leaflet.leafletId + "" + popupConfig.TITLE];
            let today = new Date().getTime();
            if (
              !lastTimeOpen ||
              lastTimeOpen +
                popupConfig.REOPENING_DAYS_DELAY * 24 * 60 * 60 * 1000 <
                today
            ) {
              canOpenPopup = true;
            }
          } else {
            canOpenPopup = true;
          }

          if (canOpenPopup) {
            setTimeout(async function() {
              // let Popup = () => import("@/components/Popup.vue");

              await global.vm.$dialog.show(Popup, {
                waitForResult: true,
                // fullscreen: global.vm.$vuetify.breakpoint.xsOnly,
                width: 700,
                popup: popupConfig,
                categoryId: _this.leaflet.leafletId
              });
            }, popupConfig.OPENING_DELAY * 1000);
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
  metaInfo() {
    return {
      title: get(this.leaflet, "title"),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: get(this.leaflet, "description")
        },
        { name: "viewport", content: "width=device-width, user-scalable=no" }
      ]
    };
  },
  async mounted() {
    this.page = this.$route.params.page || this.$route.query.page;
    // if (isNumber(this.$route.params.leafletId)) {
    //   this.slug = this.$route.params.leafletId;
    // } else {
    //   this.leafletId = this.$route.params.leafletId;
    // }
    this.leafletId = this.$route.params.leafletId;

    await this.fetchLeaflet();
    let page = Number(this.page) || 0;

    if (page > 0) {
      const isDesktop = window.innerWidth > 769;

      // apply odd-page adjustment ONLY when width > 769
      if (isDesktop && page > 1 && page % 2 !== 0) {
        page = page - 1;
      }

      const pagesToFetch = isDesktop ? [page - 1, page] : page - 1;

      await this.fetchProducts(pagesToFetch);
    } else {
      await this.fetchProducts(0);
    }

    this.checkPopup();

    if (this.$route.name === "LeafletList") {
      this.showList = true;
    } else {
      this.showList = false;
    }

    let elem = this.$refs.leafletViewer;
    elem.addEventListener("fullscreenchange", this.exitHandler, false);
    elem.addEventListener("mozfullscreenchange", this.exitHandler, false);
    elem.addEventListener("MSFullscreenChange", this.exitHandler, false);
    elem.addEventListener("webkitfullscreenchange", this.exitHandler, false);
    console.log(this.swiperHeight);

    global.EventBus.$on("openDetail", areaDetail => {
      this.openDetail(areaDetail);
    });

    global.EventBus.$on("slideChanged", index => {
      this.slideChanged(index);
    });

    if (this.$vuetify.breakpoint.smAndUp) {
      this.$nextTick(() => {
        const nav = document.getElementById("leaflet-toolbar");
        if (nav) {
          this.navOffsetTop =
            nav.getBoundingClientRect().bottom + window.scrollY;
        }
        window.addEventListener("scroll", this.handleScroll);
      });
    } else {
      this.isSticky = false;
      let t = document.getElementById("leaflet-toolbar");
      t.classList.remove("extended");
    }
    const destCategory = this.$route.query?.category
      ? Number(this.$route.query.category)
      : null;
    const categoriesIds = this.categories.map(c => c.categoryId);
    if (destCategory && categoriesIds.includes(destCategory)) {
      this.filterProducts(destCategory);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  unmouted() {
    let elem = this.$refs.leafletViewer;
    elem.removeEventListener("fullscreenchange", this.exitHandler);
    elem.removeEventListener("mozfullscreenchange", this.exitHandler);
    elem.removeEventListener("MSFullscreenChange", this.exitHandler);
    elem.removeEventListener("webkitfullscreenchange", this.exitHandler);
  },
  watch: {
    "$route.params.leafletId": async function() {
      if (isNumber(this.$route.params.leafletId)) {
        this.slug = this.$route.params.leafletId;
      } else {
        this.leafletId = this.$route.params.leafletId;
      }
      this.fetchLeaflet();
      this.fetchProducts(0);
    },
    "$vuetify.breakpoint.smAndUp"(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const nav = document.getElementById("leaflet-toolbar");
          if (nav) {
            this.navOffsetTop =
              nav.getBoundingClientRect().bottom + window.scrollY;
          }
          window.addEventListener("scroll", this.handleScroll);
        });
      } else {
        this.isSticky = false;
        const t = document.getElementById("leaflet-toolbar");
        if (t) t.classList.remove("extended");
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
    // async "$route.query.category"() {
    //   this.URLcategory = this.$route.query.categoryId;
    // },
    /**
     * Add class to disable background scrolling if leaflet is in fullscreen in ios safari/chrome
     */
    isIOSFullscreen(newValue) {
      if (newValue) {
        document.body.classList.add("body-fixed-position");
      } else {
        document.body.classList.remove("body-fixed-position");
      }
    }
  }
};
</script>
